declare namespace $ {

	export class $brand_app extends $mol_book2 {
		Theme( ): $mol_theme_auto
		Color( ): $brand_app_color
		Example( ): $brand_app_example
		title( ): string
		plugins( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map